import { dangerColors, TenantPalette } from "./tokens";

export const buildLightPalette = (p: TenantPalette) => ({
  mode: "light" as const,
  accentText: p.primary[500],
  highlight: p.accent[500],
  brand: { primary: p.primary, accent: p.accent, success: p.success, warning: p.warning },
  primary: {
    main: p.light.background,
    light: p.light.surface,
    dark: p.primary[500],
    contrastText: p.light.text,
  },
  secondary: {
    main: p.light.surface,
    light: "#323232",
    dark: p.light.surface,
    contrastText: p.light.text,
  },
  background: {
    default: p.light.surface,
    paper: p.light.background,
  },
  text: {
    primary: p.light.text,
    secondary: "rgba(0, 0, 0, 0.72)",
  },
  divider: p.light.border,
  warning: {
    main: p.warning[500],
    dark: p.warning[600],
    light: p.warning[300],
    contrastText: "#fff",
  },
  success: {
    main: p.success[600],
    dark: p.success[700],
    light: p.success[300],
    contrastText: "#fff",
  },
  error: {
    main: dangerColors.main,
    dark: dangerColors.hover,
    light: "#F47C7C",
    contrastText: "#fff",
  },
  info: {
    main: p.accent[500],
    light: p.accent[300],
    dark: p.accent[700],
    contrastText: "#fff",
  },
});
